import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import DefaultLayout from './Layout/DefaultLayout';
import Home from './Pages/Home';
import About from './Pages/About';
import Events from './Pages/Events';
import EventDetails from './Pages/EventDetails';
import Articles from './Pages/Articles';
import ArticleDetails from './Pages/ArticleDetails';
import Programs from './Pages/Programs';
import Structure from './Pages/Structure';
import SPSSRegistration from './Pages/Events/SPSSRegistration';
import SPSS2026 from './Pages/SPSS2026/SPSS2026';

//INACTIVE FORMS
//import WelparRegistration from './Pages/Events/WelparRegistration';
//import SiwuRegistration from './Pages/Events/SiwuRegistration';
//import ActivistRegistration from './Pages/Events/ActivistRegistration';

function App() {
  const router = createBrowserRouter([
    {
      path: "/spss/:slug",
      element: <SPSS2026/>,
    },
    {
      path: "/spss-2026",
      element: <Navigate to="/spss/spss-2026" replace />,
    },
    {
      
    path: "/",
      element: <DefaultLayout/>,
      children: [

        {
          index: true,
          element: <Home/>,
        },

        {
          path: "home",
          element: <Home/>
        },

        {
          path: "about",
          element: <Navigate to="/about/profile" replace />,
        },

        {
          path: "about/profile",
          element: <About/>,
        },

        {
          path: "about/vision-mission",
          element: <About/>,
        },

        {
          path: "about/logo-mascot",
          element: <About/>,
        },

        {
          path: "about/structure",
          element: <About/>,
        },

        {
          path: "events",
          element: <Events/>,
        },

        {
          path: "events/:slug",
          element: <EventDetails/>
        },

        {
          path: "articles",
          element: <Articles/>
        },

        {
          path: "articles/:ID",
          element: <ArticleDetails/>
        },

        {
          path: "programs",
          element: <Programs/>
        },

        {
          path: "structure",
          element: <Structure/>
        },

        //{
        //  path: "register-welpar",
        //  element: <WelparRegistration/>
        //},

        //{
        //  path: "siwu-registration",
        //  element: <SiwuRegistration/>
        //},

        {
          path: "register-spss-competition",
          element: <SPSSRegistration/>
        },

        //{
        //  path: "activist-registration",
        //  element: <ActivistRegistration/>
        //},

        {
          path: "*",
          element: <Navigate to="/" replace />
        }
      ] 
    },
  ])

  return (
    <RouterProvider router={router}/>
  )
}

export default App;
